/**=========================================================
 * Module: clients.js
 * Clients Controller
 =========================================================*/


 App.controller('ClientsController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', 'ngDialog',
     function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog) {
         "use strict";

         $scope.type = 'reference';

         $scope.model = {};
         $scope.error = {};
         $scope.page = {
             title: 'sidebar.nav.CLIENTS',
             subTitle: ''
         };


         $scope.initialized = false;
         $scope.watchActivated = false;
         $scope.init = function () {

             if ($rootScope.user.id && ($scope.id != 'undefined')) {
                 $scope.initialized = true;

                 if($rootScope.user.groupType=='SUPPLIER'){
                     D.query('reference', '', { cache: false }).then(function (result) {
                         $scope.references = result;
                         
                     }).catch(console.error);
                 }




             } else {
                 if (!$scope.watchActivated) {
                     $scope.watchActivated = true;
                     $rootScope.$watch('user.id', function () {
                         if (!$scope.initialized) {
                             $scope.init();
                         }
                     });
                 }
             }
         }

         

         $scope.init();
     }
 ]);